import { AdminDashboardPanel } from '@wolfejs/ms-ui/AdminDashboardPanel';
import { Button } from '@wolfejs/ui/Button';
import { Title } from '@wolfejs/ui/Title';
import { UIVariantsExtra } from '@wolfejs/ui/types/UI';
import { cn } from '@wolfejs/ui/utils/classnames';

type EmptyCartProps = {
  onContinueShopping?: () => void;
};
export const EmptyCart = ({ onContinueShopping }: EmptyCartProps) => {
  return (
    <AdminDashboardPanel
      className={cn('h-full')}
      classNames={{ wrapper: 'h-full', content: 'flex justify-center items-center h-full' }}
    >
      <div className="flex h-full w-1/2 flex-col items-center justify-center">
        <Title as="h2">Cart is empty. Please add some items.</Title>
        {onContinueShopping ? (
          <Button variant={UIVariantsExtra.alternative} onClick={onContinueShopping}>
            Continue shopping
          </Button>
        ) : null}
      </div>
    </AdminDashboardPanel>
  );
};
